








































import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import type { BaseEntry } from 'contentful';
import EditorialPushItem from 'templates/sections/EditorialPush/EditorialPushItem.vue';

import { useScreenSize } from '~/diptyqueTheme/composable/useScreenSize';
import type {
  EditorialPushItemModelFields,
  EditorialPushModel
} from '~/integrations/contentful/src/types';

type EditorialPushItemModel = EditorialPushItemModelFields & BaseEntry;

export default defineComponent<{ sectionData: EditorialPushModel & BaseEntry }>(
  {
    name: 'EditorialPush',
    components: {
      EditorialPushItem,
      VaimoTabs: () => import('molecules/VaimoTabs.vue')
    },
    props: {
      sectionData: {
        required: true,
        type: Object
      }
    },
    setup(props) {
      const { isDesktop } = useScreenSize();
      const editorialCarouselElem = ref(null);
      const activeTabIndex = ref(0);

      const getItems = computed(
        () => props.sectionData?.editorialPushItemsCollection?.items || []
      );

      const getTabs = computed(() => {
        return getItems.value.map((item: EditorialPushItemModel) => ({
          title: item.tabName,
          id: item.sys?.id
        }));
      });

      const changeSlide = (index: number) => {
        activeTabIndex.value = index;
      };

      const changeByTabClick = (index: number) => {
        if (editorialCarouselElem.value?.goTo) {
          editorialCarouselElem.value.goTo(index);
        }
      };

      return {
        isDesktop,
        editorialCarouselElem,
        changeSlide,
        activeTabIndex,
        changeByTabClick,
        getItems,
        getTabs
      };
    }
  }
);
